import React from 'react';
import { RingLoader } from 'react-spinners';
import styles from './styles.css';

const Loading = () => {
  const sty = {
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
    position: 'fixed',
    top: '0px',
    left: '0px',
    right: '0px',
    bottom: '0px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  };
  return (
    <div style={sty} className={styles.loading}>
      <RingLoader />
    </div>
  );
};

export default Loading;
